import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollToHash = () => {
    const location = useLocation();

    useEffect(() => {
        const hash = window.location.hash;

        if (hash) {
            document.querySelector(hash)?.scrollIntoView({
                behavior: "smooth",
            });
        }
    }, [location]);
};

export default useScrollToHash;